/** Generic */
export const GA_ACTION_CLICK = 'Click';
export const GA_ACTION_VIEW = 'View';
export const GA_ACTION_HOVER = 'Hover';
export const GA_NAME_PAGE_VIEW = 'page_view';

/** Financial Offers */
export const CREDIT_CARD_OFFERS_GA_CATEGORY = 'Credit Card Offers';
export const HYSA_GA_CATEGORY = 'HYSA';
export const MARKETPLACE_CREDIT_CARD_OFFERS_GA_CATEGORY = `Marketplace - ${CREDIT_CARD_OFFERS_GA_CATEGORY}`;
